// Formateadores compartidos. Antes de crear este archivo se compararon (con
// Node, no de memoria) las 6 implementaciones de "money"/"dinero"/"formatMonto"
// y las 3 de "pct"/"porcentaje"/"percent" que existían repetidas en
// Dashboard.js, Equipo.js, Superadmin.js, MenuEngineering.js y PnL.js.
//
// Resultado de la comparación:
//  - Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}) e
//    Intl.NumberFormat('es-US', {...}) producen exactamente el mismo texto
//    para USD (verificado: "$1,234.50" en ambos casos, también en negativos).
//    Esas 4 implementaciones eran, en la práctica, la misma función.
//  - El "money" de Superadmin.js es distinto a propósito: usa
//    maximumFractionDigits:0 (dólares enteros, para cifras de MRR). Se
//    conserva como variante separada, no se fusiona.
//  - El "formatMonto" de Ventas.js (POS) NO se toca: usa un enfoque distinto
//    (prefijo "$" manual + toLocaleString('es-MX')) que, con números
//    negativos, se comporta distinto a Intl.NumberFormat ("$-1.50" vs
//    "-$1.50"). Es la pantalla de cobro real — no vale la pena el riesgo de
//    unificarlo solo por estética. Sigue viviendo en Ventas.js sin cambios.

export function formatMoneda(valor, decimales = 2) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  }).format(Number(valor) || 0);
}

// Variante en dólares enteros (sin centavos) — la que ya usaba Superadmin.js
// para MRR y cifras grandes del panel de la plataforma.
export function formatMonedaEntera(valor) {
  return formatMoneda(valor, 0);
}

export function formatPorcentaje(valor, decimales = 1) {
  return `${Number(valor || 0).toFixed(decimales)}%`;
}
